import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { LostConnectionComponent } from './lost-connection.component';

@Injectable({ providedIn: 'root' })
export class LostConnectionDialog {
  readonly #dialog = inject(DialogService);

  open(): DialogRef {
    return this.#dialog.open(LostConnectionComponent);
  }
}
